self.MonacoEnvironment = {
    getWorkerUrl(moduleId, label) {
        const PUBLIC_PATH = __webpack_public_path__ || '';
        if (label === 'typescript' || label === 'javascript') {
            return `${PUBLIC_PATH}static/js/ts.worker.js`;
        }
        if (label === 'greycat') {
            return `${PUBLIC_PATH}static/js/gc.worker.js`;
        }
        return `${PUBLIC_PATH}static/js/editor.worker.js`;
    },
};
